import React, { useEffect, useState } from 'react'
import { EditReview } from '../../redux/Slices/ReviewsSlice'
import { useDispatch, useSelector } from 'react-redux'
import notify from '../UseNotification'

const UseEditReview = (item) => {
    const dispatch = useDispatch()
    const [EditShow, setEditShow] = useState(false)
    const [loading, setLoading] = useState(false)
    const [rateText, setRateText] = useState(item.review)
    const [ratevalue, setRateValue] = useState(item.rating)
    const { editReview } = useSelector(state => state.ReviewsReducer)

    
    // handle edit close
    const handleEditClose = () => {
        setEditShow(false)
    }

    // handle edit show
    const handleEditShow = () => {
        setEditShow(true)
    }

    // on change rate value
    const onChangeReviewValue = (val) => {
        setRateValue(val)
    }

    // on change rate text
    const onChangeRateText = (e) => {
        setRateText(e.target.value)
    }

    // handle edit review
    const handleEditReview = async () => {
        setLoading(true)
        await dispatch(EditReview({
            id: item._id,
            data: {
                review: rateText,
                rating: ratevalue
            }
        }))
        handleEditClose()
        setLoading(false)
    }

    // handle the edit view request response
    useEffect(() => {
        if (loading === false) {
            if (editReview.status === 200) {
                notify("your review is upadated", "success")
                window.location.reload(false)
            }
        }
    }, [loading])


    return [rateText, ratevalue, onChangeReviewValue, onChangeRateText, EditShow, handleEditClose, handleEditReview, handleEditShow]
}

export default UseEditReview
